export default __webpack_public_path__ + "3c6bbceed4ed40be76805c4db70d4392.ttf";